import { render } from "./NoteProgress.vue?vue&type=template&id=ef05df3e&scoped=true&ts=true"
import script from "./NoteProgress.vue?vue&type=script&lang=ts"
export * from "./NoteProgress.vue?vue&type=script&lang=ts"

import "./NoteProgress.vue?vue&type=style&index=0&id=ef05df3e&scoped=true&lang=less"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_h5_base_frame_refs-heads-master/source_code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef05df3e"]])

export default __exports__